import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Options } from 'focus-trap';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

import { State } from '®app/ngrx/state';
import { AppConfig } from '®shared/config/app-config';
import { UserPermissions } from '®shared/permissions';

import {
  NodesEditorHideModalAction,
  NodesEditorNewListHideModalAction,
  NodesEditorNewListPersistNodesAction,
  NodesEditorSaveNodesAction,
} from './nodes-editor-modal.actions';
import {
  HierarchyEditorState,
  selectNodeEditorModalState,
} from './nodes-editor.state';

@Component({
  selector: 'rl-nodes-editor-modal',
  templateUrl: './nodes-editor-modal.component.html',
})
export class NodesEditorModalComponent implements OnDestroy, OnInit {
  @Input() permissions: UserPermissions;
  @Input() isNewList = false;

  @ViewChild('nodesEditorModal', { static: true })
  public nodesEditorModal: ModalDirective;

  focusTrapConfig: Options = {
    setReturnFocus: '#edit-list-btn',
    allowOutsideClick: true, // Ensure material autocomplete can be clicked on
  };

  private stateSubscription: Subscription;

  hierarchyEditor: HierarchyEditorState | null;
  isModalShown: boolean;
  isHierarchyUpdateEnabled: boolean;

  constructor(
    private appConfig: AppConfig,
    private cd: ChangeDetectorRef,
    private store: Store<State>,
  ) {
    this.isHierarchyUpdateEnabled =
      this.appConfig.tenant.hierarchy.isHierarchyUpdateEnabled;
  }

  ngOnInit() {
    this.stateSubscription = this.store
      .select(selectNodeEditorModalState)
      .subscribe(state => {
        const { hierarchyEditor, isModalShown } = state;
        this.hierarchyEditor = hierarchyEditor;
        this.isModalShown = isModalShown;

        // open/close modal according to state
        if (isModalShown && !this.nodesEditorModal.isShown) {
          this.nodesEditorModal.show();
        } else if (!isModalShown && this.nodesEditorModal.isShown) {
          this.nodesEditorModal.hide();
        }

        this.cd.markForCheck();
      });
  }

  ngOnDestroy() {
    if (this.stateSubscription) {
      this.stateSubscription.unsubscribe();
    }
  }

  onSave(
    action: NodesEditorSaveNodesAction | NodesEditorNewListPersistNodesAction,
  ) {
    this.store.dispatch(action);
  }

  onHide() {
    const action = this.isNewList
      ? new NodesEditorNewListHideModalAction()
      : new NodesEditorHideModalAction();

    this.store.dispatch(action);
  }
}
